module.exports = __webpack_public_path__ + "static/media/default-image.4affbbf6.svg";